import { defineMessages } from 'react-intl';

export default defineMessages({
  skinTone: {
    id: 'cboard.components.SkinTone.skinTone',
    defaultMessage: 'Skin Tone'
  },
  skinToneDisabled: {
    id: 'cboard.components.SkinTone.skinToneDisabled',
    defaultMessage:
      'Skin tone options are only available for ARASAAC and Cboard Symbols'
  },
  clearSelection: {
    id: 'cboard.components.SkinTone.clearSelection',
    defaultMessage: 'Clear selection'
  }
});
